module.exports = __webpack_public_path__ + "e6a28e060cab0941e34115ae98196fbc.svg";